import { ButtonPropsDto } from './ButtonPropsDto';
import { IconPropsDto } from './IconPropsDto';
import { PopupPropsDto } from './PopupPropsDto';
import { VideoPropsDto } from './VideoPropsDto';
import { EmbedPropsDto } from './EmbedPropsDto';
import { PagePropsDto } from './PagePropsDto';
import { ImagePropsDto } from './ImagePropsDto';
import { FormPropsDto } from './FormPropsDto';
import { TextPropsDto } from './TextPropsDto';
import { FormEmailFieldPropsDto } from './FormEmailFieldPropsDto';
import { FormConsentFieldPropsDto } from './FormConsentFieldPropsDto';
import { FormDropdownFieldPropsDto } from './FormDropdownFieldPropsDto';
import { ContainerPropsDto } from './ContainerPropsDto';
import { FormPhoneFieldPropsDto } from './FormPhoneFieldPropsDto';
import { FormTextFieldPropsDto } from './FormTextFieldPropsDto';
import { CountdownPropsDto } from './CountdownPropsDto';
import {
  BUTTON_NODE_NAME,
  VIDEO_NODE_NAME,
  EMBED_NODE_NAME,
  PAGE_NODE_NAME,
  IMAGE_NODE_NAME,
  ICON_NODE_NAME,
  FORM_NODE_NAME,
  TEXT_NODE_NAME,
  FORM_EMAIL_FIELD_NODE_NAME,
  FORM_CONSENT_FIELD_NODE_NAME,
  FORM_DROPDOWN_FIELD_NODE_NAME,
  POPUP_NODE_NAME,
  CONTENT_BLOCK_NAME,
  FORM_PHONE_FIELD_NODE_NAME,
  FORM_TEXT_FIELD_NODE_NAME,
  COUNTDOWN_NODE_NAME,
} from '@builder4/shared/utils/constants';

type DtoConstructor = new () => object;

/**
 * Registry mapping component displayName to their props DTO class.
 * Components not in this registry will use fallback validation (any object accepted).
 */
const PROPS_DTO_REGISTRY = new Map<string, DtoConstructor>([
  [BUTTON_NODE_NAME, ButtonPropsDto],
  [ICON_NODE_NAME, IconPropsDto],
  [POPUP_NODE_NAME, PopupPropsDto],
  [VIDEO_NODE_NAME, VideoPropsDto],
  [EMBED_NODE_NAME, EmbedPropsDto],
  [PAGE_NODE_NAME, PagePropsDto],
  [IMAGE_NODE_NAME, ImagePropsDto],
  [FORM_NODE_NAME, FormPropsDto],
  [TEXT_NODE_NAME, TextPropsDto],
  [FORM_EMAIL_FIELD_NODE_NAME, FormEmailFieldPropsDto],
  [FORM_CONSENT_FIELD_NODE_NAME, FormConsentFieldPropsDto],
  [FORM_DROPDOWN_FIELD_NODE_NAME, FormDropdownFieldPropsDto],
  [CONTENT_BLOCK_NAME, ContainerPropsDto],
  [FORM_PHONE_FIELD_NODE_NAME, FormPhoneFieldPropsDto],
  [FORM_TEXT_FIELD_NODE_NAME, FormTextFieldPropsDto],
  [COUNTDOWN_NODE_NAME, CountdownPropsDto],
]);

/**
 * Get the props DTO class for a given component displayName.
 * Returns undefined if no specific DTO is registered (fallback to generic validation).
 */
export function getPropsDto(displayName: string): DtoConstructor | undefined {
  return PROPS_DTO_REGISTRY.get(displayName);
}
